module.exports = __webpack_public_path__ + "media/images/twitter-c12be1da13531dd7ac1917d2fe3fb0ed.svg";